import actions from './actions';
import getters from './getters';

export default {
  namespaced: true,
  state: {
    has_projects_loaded: false,
    projects_list: [],
    has_categories_loaded: false,
    categories_list: [],
    has_features_loaded: false,
    features_list: [],
    has_stages_loaded: false,
    stages_list: [],
    has_plans_loaded: false,
    plans_list: [],
    has_contacts_loaded: false,
    contacts_list: [],
    has_timesheets_loaded: false,
    timesheets_list: [],
    has_expenses_loaded: false,
    expenses_list: [],
    has_roles_loaded: false,
    roles_list: [],
    has_users_loaded: false,
    users_list: [],
    has_stats_loaded: false,
    stats_list: [],
    has_dashboard_stats_loaded: false,
    dashboard_stats_list: {},
  },
  getters,
  mutations: {},
  actions,
};
